import { InputOption } from "../form/fields";
import {
  ApplicationType,
  FunctionType,
  PreferredMailingAddress,
  Title,
} from "./types";
export const ApplicationTypeOptions: InputOption<ApplicationType>[] = [
  {
    text: "Licensed member",
    value: ApplicationType.licensedMember,
  },
  {
    text: "Representative member",
    value: ApplicationType.representativeMember,
  },
];

export const TitleOptions: InputOption<Title>[] = [
  {
    text: "Mr",
    value: Title.mr,
  },
  {
    text: "Miss",
    value: Title.miss,
  },
  {
    text: "Mrs",
    value: Title.mrs,
  },
  {
    text: "Ms",
    value: Title.ms,
  },
];

export const PreferredMailingAddressOptions: InputOption<PreferredMailingAddress>[] =
  [
    {
      text: "As above",
      value: PreferredMailingAddress.office,
    },

    {
      text: "Alternative",
      value: PreferredMailingAddress.other,
    },
  ];

export const FunctionTypeOptions: InputOption<FunctionType>[] = [
  {
    text: FunctionType.Auctioneering,
    value: FunctionType.Auctioneering,
  },
  {
    text: FunctionType.OCM,
    value: FunctionType.OCM,
  },
  {
    text: FunctionType.BB,
    value: FunctionType.BB,
  },
  {
    text: FunctionType.PV,
    value: FunctionType.PV,
  },
  {
    text: FunctionType.BA,
    value: FunctionType.BA,
  },
  {
    text: FunctionType.RLM,
    value: FunctionType.RLM,
  },
  {
    text: FunctionType.CILM,
    value: FunctionType.CILM,
  },
  {
    text: FunctionType.RS,
    value: FunctionType.RS,
  },
  {
    text: FunctionType.CIS,
    value: FunctionType.CIS,
  },
  {
    text: FunctionType.FRL,
    value: FunctionType.FRL,
  },
];
